import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { trackEvent } from "../lib/analytics";
import { whatsappHref, SITE } from "../config/site";

const base =
  "group inline-flex items-center justify-center gap-2 text-sm font-semibold tracking-wide transition-colors duration-300 rounded-none px-7 py-3.5";

export const BookCallButton = ({
  label = "Book a Strategy Call",
  className = "",
  testid = "book-call-button",
  dark = false,
}) => {
  return (
    <Link
      to={"/contact"}
      data-testid={testid}
      onClick={() => trackEvent("cta_click", { cta: "book_strategy_call", label })}
      className={`${base} ${
        dark
          ? "bg-cream text-charcoal hover:bg-gold"
          : "bg-tan text-cream hover:bg-charcoal"
      } ${className}`}
    >
      {label}
      <ArrowUpRight
        size={16}
        strokeWidth={1.5}
        className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
      />
    </Link>
  );
};

export const BlueprintButton = ({
  label = "Free Customer Growth Blueprint",
  className = "",
  testid = "growth-blueprint-button",
  light = false,
}) => {
  return (
    <a
      href={SITE.blueprintUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={() => trackEvent("cta_click", { cta: "growth_blueprint", label })}
      className={`${base} border bg-transparent ${
        light
          ? "border-cream/40 text-cream hover:border-gold hover:text-gold"
          : "border-charcoal/25 text-charcoal hover:border-gold hover:text-tan"
      } ${className}`}
    >
      {label}
    </a>
  );
};

export const WhatsAppButton = ({
  label = "Start a WhatsApp Conversation",
  fallback = "/contact",
  className = "",
  testid = "whatsapp-cta-button",
  light = false,
}) => {
  const href = whatsappHref(fallback);
  const external = href.startsWith("http");
  const cls = `${base} border ${
    light
      ? "border-cream/40 text-cream hover:border-gold hover:text-gold"
      : "border-charcoal/25 text-charcoal hover:border-gold hover:text-tan"
  } ${className}`;
  const inner = (
    <>
      <MessageCircle size={16} strokeWidth={1.5} />
      {label}
    </>
  );
  return external ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={() => trackEvent("whatsapp_click", { placement: testid })}
      className={cls}
    >
      {inner}
    </a>
  ) : (
    <Link
      to={href}
      data-testid={testid}
      onClick={() => trackEvent("whatsapp_click", { placement: testid, fallback: true })}
      className={cls}
    >
      {inner}
    </Link>
  );
};

export const ArrowLink = ({ to: target, children, className = "", testid, dark = false }) => {
  return (
    <Link
      to={target}
      data-testid={testid}
      className={`group inline-flex items-center gap-2 text-sm font-semibold ${
        dark ? "text-gold" : "text-tan"
      } ${className}`}
    >
      {children}
      <ArrowUpRight
        size={15}
        strokeWidth={1.5}
        className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5"
      />
    </Link>
  );
};
